// const getPELabel = (item) => String(item?.name || '').split('-')[0].trim()
const getPELabel = (item) => String(item?.name || '')


const escapePEHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')

const getSelectedPEChildren = (item) => (item?.hierarchy || []).filter((child) => child?.isSelected === true)

const renderPELabel = (item) => {
  const label = escapePEHtml(getPELabel(item))

  if (item?.type !== 'title') return label

  return `<span style="text-decoration:underline; text-underline-offset:4px;">${label}</span>`
}

const getPEInput = (item) => {
  if (typeof item?.inputData !== 'string') return ''

  const value = item.inputData.trim()
  if (!value || ['enter value', 'enter test'].includes(value.toLowerCase())) return ''

  return value
}

const formatPELeaf = (item) => {
  const label = renderPELabel(item)
  const input = escapePEHtml(getPEInput(item))

  if (!input) return label
  if (getPELabel(item).toLowerCase() === 'unable to test') return `${label} (${input})`

  return `${label}: ${input}`
}

const getInlinePEValue = (item) => {
  const children = getSelectedPEChildren(item)
  if (children.length === 0) return formatPELeaf(item)

  if (getPELabel(item).toLowerCase() === 'yes') {
    const values = children.map(getInlinePEValue)
    return values.every(Boolean) ? values.join(', ') : null
  }

  if (!children.every((child) => getSelectedPEChildren(child).length === 0)) return null

  const values = children.map(formatPELeaf).filter(Boolean)
  if (values.length === 0) return formatPELeaf(item)

  return `<strong>${renderPELabel(item)}:</strong> ${values.join(', ')}`
}

const getRecursiveInlinePEValue = (item) => {
  const children = getSelectedPEChildren(item)
  if (children.length === 0) return formatPELeaf(item)

  if (getPELabel(item).toLowerCase() === 'yes') {
    const values = children.map(getRecursiveInlinePEValue).filter(Boolean)
    return values.length > 0 ? values.join(', ') : null
  }

  const values = children.map(getRecursiveInlinePEValue).filter(Boolean)
  if (values.length === 0) return formatPELeaf(item)

  return `<strong>${renderPELabel(item)}:</strong> ${values.join(', ')}`
}

const peListStyle = (depth) => ['disc', 'circle', 'square'][depth % 3]

const renderPEList = (items, depth) => {
  const selectedItems = items.filter((item) => item?.isSelected === true)
  if (selectedItems.length === 0) return ''

  return `<ul style="margin:6px 0 8px 0; padding-left:${28 + depth * 4}px; list-style-type:${peListStyle(depth)};">${selectedItems.map((item) => renderPEItem(item, depth)).join('')}</ul>`
}

const renderPEItem = (item, depth) => {
  const label = getPELabel(item)
  const children = getSelectedPEChildren(item)
  const listItemStyle = `margin:4px 0; padding-left:2px;${item?.type === 'title' ? ' list-style-type:none;' : ''}`

  if (children.length === 0) {
    return `<li style="${listItemStyle}">${formatPELeaf(item)}</li>`
  }

  if (label.toLowerCase() === 'yes') return children.map((child) => renderPEItem(child, depth)).join('')

  const shouldFlattenNestedValues = item.rowAlign === true || item.hierarchyType === 'single'
  const inlineValues = children.map((child) => (shouldFlattenNestedValues ? getRecursiveInlinePEValue(child) : getInlinePEValue(child)))
  const childrenAreLeaves = children.every((child) => getSelectedPEChildren(child).length === 0)
  const canRenderOnOneLine = inlineValues.every(Boolean) && (childrenAreLeaves || shouldFlattenNestedValues)
  const input = getPEInput(item)

  if (canRenderOnOneLine) {
    const inputText = input ? ` <span>(${escapePEHtml(input)})</span>` : ''
    return `<li style="${listItemStyle}"><strong>${renderPELabel(item)}:</strong> ${inlineValues.join(', ')}${inputText}</li>`
  }

  const inputText = input ? `: ${escapePEHtml(input)}` : ''
  return `<li style="${listItemStyle}"><strong>${renderPELabel(item)}</strong>${inputText}${renderPEList(children, depth + 1)}</li>`
}

export const formatPhysicalExaminationHTML = (data = []) =>
  data
    .filter((section) => section?.type === 'accordion' && getSelectedPEChildren(section).length > 0)
    .map(
      (section) =>
        `<div style="margin-bottom:18px;"><div style="font-size:16px; font-weight:700; margin-bottom:6px;">${escapePEHtml(getPELabel(section))}</div>${renderPEList(section.hierarchy || [], 0)}</div>`,
    )
    .join('')
